<div class="profile-page">
  <h1 class="page-title">Profile</h1>
  <p class="page-sub">Your account and password. School admins also see Teachers and User directory (same user list; teachers are users with the teacher role).</p>

  <mat-tab-group animationDuration="0ms" class="profile-tabs">
    <mat-tab label="My account">
      <div class="tab-body">
        <div *ngIf="loadingMe" class="state-row">
          <mat-spinner diameter="36"></mat-spinner>
          <span>Loading profile…</span>
        </div>
        <mat-card *ngIf="!loadingMe && loadMeError" class="warn-card">
          <mat-card-content>{{ loadMeError }}</mat-card-content>
        </mat-card>

        <div *ngIf="!loadingMe" class="two-col">
          <mat-card>
            <mat-card-title>Contact & name</mat-card-title>
            <mat-card-content>
              <form [formGroup]="profileForm" (ngSubmit)="saveProfile()">
                <mat-form-field appearance="outline" class="full">
                  <mat-label>Username</mat-label>
                  <input matInput formControlName="username" />
                </mat-form-field>
                <div class="row2">
                  <mat-form-field appearance="outline">
                    <mat-label>First name</mat-label>
                    <input matInput formControlName="firstName" required />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Last name</mat-label>
                    <input matInput formControlName="lastName" required />
                  </mat-form-field>
                </div>
                <mat-form-field appearance="outline" class="full">
                  <mat-label>Email</mat-label>
                  <input matInput type="email" formControlName="email" />
                  <mat-error *ngIf="profileForm.get('email')?.errors?.email">Invalid email</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full">
                  <mat-label>Mobile / phone</mat-label>
                  <input matInput formControlName="phoneNumber" />
                </mat-form-field>
                <button mat-flat-button color="primary" type="submit" [disabled]="profileForm.invalid || savingProfile">
                  {{ savingProfile ? 'Saving…' : 'Save changes' }}
                </button>
              </form>
            </mat-card-content>
          </mat-card>

          <mat-card>
            <mat-card-title>Change password</mat-card-title>
            <mat-card-content>
              <form [formGroup]="passwordForm" (ngSubmit)="changePassword()">
                <mat-form-field appearance="outline" class="full">
                  <mat-label>Current password</mat-label>
                  <input
                    matInput
                    formControlName="currentPassword"
                    [type]="hideCurrent ? 'password' : 'text'"
                    autocomplete="current-password"
                  />
                  <button mat-icon-button matSuffix type="button" (click)="hideCurrent = !hideCurrent">
                    <mat-icon>{{ hideCurrent ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full">
                  <mat-label>New password</mat-label>
                  <input
                    matInput
                    formControlName="newPassword"
                    [type]="hideNew ? 'password' : 'text'"
                    autocomplete="new-password"
                  />
                  <button mat-icon-button matSuffix type="button" (click)="hideNew = !hideNew">
                    <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full">
                  <mat-label>Confirm new password</mat-label>
                  <input
                    matInput
                    formControlName="confirmPassword"
                    [type]="hideConfirm ? 'password' : 'text'"
                    autocomplete="new-password"
                  />
                  <button mat-icon-button matSuffix type="button" (click)="hideConfirm = !hideConfirm">
                    <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="passwordForm.hasError('mismatch')">Passwords do not match</mat-error>
                </mat-form-field>
                <button mat-stroked-button color="primary" type="submit" [disabled]="passwordForm.invalid || savingPassword">
                  {{ savingPassword ? 'Updating…' : 'Change password' }}
                </button>
              </form>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Teachers" *ngIf="isAdmin">
      <div class="tab-body">
        <p class="tab-help">Accounts with role ROLE_TEACHER (same user directory as the school; teachers are not a separate entity).</p>
        <div class="dir-toolbar">
          <button mat-flat-button color="primary" type="button" (click)="openAddTeacherFromProfile()" [disabled]="tenantId == null">
            <mat-icon>person_add</mat-icon>
            Add teacher
          </button>
        </div>
        <div *ngIf="loadingDirectory" class="state-row">
          <mat-spinner diameter="32"></mat-spinner>
        </div>
        <table mat-table [dataSource]="teacherDirectory" *ngIf="!loadingDirectory" class="dir-table">
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef>Username</th>
            <td mat-cell *matCellDef="let row">{{ row.username }}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let row">{{ row.firstName }} {{ row.lastName }}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let row">{{ row.email }}</td>
          </ng-container>
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>Phone</th>
            <td mat-cell *matCellDef="let row">{{ row.phoneNumber || row.mobileNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="roles">
            <th mat-header-cell *matHeaderCellDef>Roles</th>
            <td mat-cell *matCellDef="let row">{{ rolesText(row) }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button type="button" color="primary" matTooltip="Edit user" (click)="openEditUser(row)">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="directoryColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: directoryColumns"></tr>
        </table>
        <p *ngIf="!loadingDirectory && !teacherDirectory.data.length" class="empty">No teacher-role users in this tenant.</p>
      </div>
    </mat-tab>

    <mat-tab label="User directory" *ngIf="isAdmin">
      <div class="tab-body">
        <p class="tab-help">All users in your tenant (GET /api/v1/users). Edit names, contact, or set a new password. Use Provision user to add an admin or teacher (same signup API; pick role).</p>
        <div class="dir-toolbar">
          <button mat-stroked-button color="primary" type="button" (click)="openProvisionUserFromProfile()" [disabled]="tenantId == null">
            <mat-icon>person_add</mat-icon>
            Provision user
          </button>
        </div>
        <div *ngIf="loadingDirectory" class="state-row">
          <mat-spinner diameter="32"></mat-spinner>
        </div>
        <table mat-table [dataSource]="userDirectory" *ngIf="!loadingDirectory" class="dir-table">
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef>Username</th>
            <td mat-cell *matCellDef="let row">{{ row.username }}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let row">{{ row.firstName }} {{ row.lastName }}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let row">{{ row.email }}</td>
          </ng-container>
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>Phone</th>
            <td mat-cell *matCellDef="let row">{{ row.phoneNumber || row.mobileNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="roles">
            <th mat-header-cell *matHeaderCellDef>Roles</th>
            <td mat-cell *matCellDef="let row">{{ rolesText(row) }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button type="button" color="primary" matTooltip="Edit user" (click)="openEditUser(row)">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="directoryColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: directoryColumns"></tr>
        </table>
        <p *ngIf="!loadingDirectory && !userDirectory.data.length" class="empty">No users returned.</p>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
